// removed by extract-text-webpack-plugin
module.exports = {"m":"(min-width: 48em)","l":"(min-width: 64em)"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ApplicationWindow.css
// module id = 562
// module chunks = 2